import React from 'react';

function Advertisers() {
  return <h1>Advertisers Page</h1>;
}

export default Advertisers;